import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MFChannel } from '../../../Components/SDK';
import {
   appendRecentChannels,
   selectChannelsData,
   selectFilteredRecentChatData,
   selectRecentChatData,
   selectSearchTextByScope,
   setMultipleChannelsInfo,
   setRecentChannelHasMore,
   setRecentChannelLoading,
   setSearchTextByScope,
} from '../../../Slice';

const PAGE_SIZE = 10;

// Helper function to check if channel is unique
const isUniqueChannel = (accumulator, channel) => {
   return !accumulator.find(c => c.channelId === channel.channelId);
};

// Helper function to get unique channels from array
const getUniqueChannels = channels => {
   return channels.reduce((acc, channel) => {
      if (isUniqueChannel(acc, channel)) {
         acc.push(channel);
      }
      return acc;
   }, []);
};

export const useRecentChannels = (scopeKey = 'page', loadingRef = null) => {
   const dispatch = useDispatch();

   const channelList = useSelector(selectFilteredRecentChatData(scopeKey));
   const allChannels = useSelector(selectRecentChatData);
   const searchText = useSelector(selectSearchTextByScope(scopeKey));
   const { loading, hasMore } = useSelector(selectChannelsData);

   const fetchRecentChannelList = useCallback(async () => {
      if (!hasMore || loading) {
         return;
      }

      dispatch(setRecentChannelLoading(true));
      try {
         const lastChannel = allChannels[allChannels.length - 1];
         const lastActivityAt = lastChannel?.lastActivityAt || 0;
         

         const response = await MFChannel.fetchRecentChannels({
            size: PAGE_SIZE,
            lastActivityAt,
         });
         const newChannels = response?.data?.channels || [];

         if (newChannels.length > 0) {
            const uniqueChannels = getUniqueChannels(newChannels);

            dispatch(setMultipleChannelsInfo(uniqueChannels));
            dispatch(appendRecentChannels(uniqueChannels));
         }

         dispatch(setRecentChannelHasMore(newChannels.length > 0));
      } catch (error) {
         console.error('Error fetching channels:', error);
         dispatch(setRecentChannelHasMore(false));
      } finally {
         dispatch(setRecentChannelLoading(false));
      }
   }, [dispatch, hasMore, loading, allChannels]);

//    const loadMore = useCallback(() => {
//       fetchRecentChannelList();
//    }, [fetchRecentChannelList]);

   const updateSearchText = useCallback(
      text => {
         dispatch(setSearchTextByScope({ scopeKey, searchText: text }));
      },
      [dispatch, scopeKey],
   );

   const reset = useCallback(() => {
      dispatch(setSearchTextByScope({ scopeKey, searchText: '' }));
   }, [dispatch, scopeKey]);

   useEffect(() => {
      return () => {
         dispatch(setSearchTextByScope({ scopeKey, searchText: '' }));
      };
   }, [dispatch, scopeKey]);

   return {
      channelList,
      hasMore,
    //   loadMore,
      loading,
      updateSearchText,
      searchText,
      reset,
      fetchRecentChannelList,
      allChannels,
   };
};
